import * as types from '../../types'
import Immutable from 'immutable'

const INITIAL_STATE = Immutable.fromJS({
    cafeterias: [],
    saving: false,
    modalGenerateInterfaz: {
        show: false,
        data: {}
    }
})

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.INTERFAZCONTABLE_REINICIAR_ESTADO:
            state = state.set('cafeteria', '');
            state = state.set('filter', '');
            state = state.set('false', false);
            state = state.set('modalGenerateInterfaz', INITIAL_STATE.get('modalGenerateInterfaz'));
            return state
        case types.INTERFAZCONTABLE_GUARDANDO:
            state = state.set('saving', action.payload)
            return state
        case types.INTERFAZCONTABLE_MOSTRAR_MODAL_GENERAR_INTERFAZ:
            state = state.setIn('modalGenerateInterfaz.show'.split('.'), action.payload.show)
            if (!action.payload.show) {
                state = state.set('modalGenerateInterfaz', INITIAL_STATE.get('modalGenerateInterfaz'))
            } else {
                state = state.setIn('modalGenerateInterfaz.data.solicitudes'.split('.'), action.payload.solicitudes)
            }
            return state

        default:
            return state
    }
}